var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "275px",
    height: "23.5px",
    viewBox: "0 0 275 23.5",
    enableBackground: "new 0 0 275 23.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.912,
    y: 2.103,
    opacity: 0.2,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    width: 66.463,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.292,
    y: 2.103,
    opacity: 0.2,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    width: 65.249,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    d: "M204.518,2.103h-65.059v20h64.747 C204.304,15.437,204.461,8.771,204.518,2.103z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    d: "M207.436,2.103c-0.057,6.667-0.214,13.333-0.312,20h66.763v-20 H207.436z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadBar);
export default __webpack_public_path__ + "static/media/load_bar.820413acb73f8d4220b6c4b058bdfad2.svg";
export { ForwardRef as ReactComponent };